export default __webpack_public_path__ + "static/media/downloadfromapple.328eef7b.png";